import {createFileRoute} from '@tanstack/react-router';

import {deployOverviewTabQueryParam} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {DeployOverview} from '~components/deploy/DeployOverview';

export const Route = createFileRoute('/deploy/')({
  component: DeployPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      [deployOverviewTabQueryParam]: (search[deployOverviewTabQueryParam] as string) || undefined,
      projectID: (search.projectID as string) || undefined,
    };
  },
});

function DeployPage(): JSX.Element | null {
  return (
    <BaseLayout withTitleDivider customContentAndFooter>
      <DeployOverview />
    </BaseLayout>
  );
}
